var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logistic-map"},[_c('div',{staticClass:"logistic-map__wrapper"},[_c('object',{ref:"map",staticClass:"logistic-map__svg",attrs:{"type":"image/svg+xml","data":_vm.svgSrc}},[_vm._v("Your browser does not support SVGs")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }